var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 313,
    viewBox: "0 0 314 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.858984 1.97977C0.558984 2.67978 0.458984 72.7798 0.558984 157.78L0.858984 312.28L157.159 312.58L313.359 312.78V156.78V0.779785H157.359C33.459 0.779785 1.15898 1.07977 0.858984 1.97977ZM305.359 156.78V305.78H156.859H8.35898V156.78V7.77979H156.859H305.359V156.78Z",
    fill: "#159615"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.358 53.8796C126.658 55.9796 107.958 63.8796 94.7585 73.2796C88.9585 77.3796 74.6585 92.4796 70.1585 99.2796C42.4585 141.38 48.6585 197.38 85.0585 231.78C101.358 247.28 121.458 256.98 143.058 259.88C163.658 262.58 185.358 258.98 204.058 249.48C208.558 247.28 213.358 244.48 214.758 243.38C216.058 242.18 218.258 240.58 219.558 239.78C224.558 236.58 239.258 220.98 243.558 214.28C251.258 202.48 256.658 188.98 259.458 175.28C261.858 163.28 260.758 140.28 257.158 128.78C254.458 119.88 249.658 108.98 246.658 104.48C244.858 101.78 243.358 99.3796 243.358 99.0796C243.358 96.8796 227.158 79.3796 219.758 73.6796C214.358 69.4796 199.558 61.4796 192.858 59.0796C178.158 53.7796 155.658 51.5796 140.358 53.8796Z",
    fill: "#159615"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeg);
export default __webpack_public_path__ + "static/media/veg.45939c1be0edac16e16404291201c31c.svg";
export { ForwardRef as ReactComponent };